/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v3";
import { remap as remap$ } from "../../lib/primitives.js";
import { safeParse } from "../../lib/schemas.js";
import { Result as SafeParseResult } from "../../types/fp.js";
import * as types from "../../types/primitives.js";
import { SDKValidationError } from "../errors/sdkvalidationerror.js";
import {
  DisplayRef,
  DisplayRef$inboundSchema,
  DisplayRef$Outbound,
  DisplayRef$outboundSchema,
} from "./displayref.js";

/**
 * Trendable data points for a given device.
 */
export type DeviceTrendPoints = {
  /**
   * The alias of the device.
   */
  alias: string;
  /**
   * All display refs.
   */
  allDisplayRefs: Array<DisplayRef>;
  /**
   * The default set of display refs, includes Display Template Metrics + Mode.
   */
  defaultDisplayRefs: Array<DisplayRef>;
  /**
   * The id of the device.
   */
  deviceId: string;
  /**
   * The display name of the device.
   */
  displayName: string;
  /**
   * The kind of the device.
   */
  kind: string;
};

/** @internal */
export const DeviceTrendPoints$inboundSchema: z.ZodType<
  DeviceTrendPoints,
  z.ZodTypeDef,
  unknown
> = z.object({
  alias: types.string(),
  all_display_refs: z.array(DisplayRef$inboundSchema),
  default_display_refs: z.array(DisplayRef$inboundSchema),
  device_id: types.string(),
  display_name: types.string(),
  kind: types.string(),
}).transform((v) => {
  return remap$(v, {
    "all_display_refs": "allDisplayRefs",
    "default_display_refs": "defaultDisplayRefs",
    "device_id": "deviceId",
    "display_name": "displayName",
  });
});
/** @internal */
export type DeviceTrendPoints$Outbound = {
  alias: string;
  all_display_refs: Array<DisplayRef$Outbound>;
  default_display_refs: Array<DisplayRef$Outbound>;
  device_id: string;
  display_name: string;
  kind: string;
};

/** @internal */
export const DeviceTrendPoints$outboundSchema: z.ZodType<
  DeviceTrendPoints$Outbound,
  z.ZodTypeDef,
  DeviceTrendPoints
> = z.object({
  alias: z.string(),
  allDisplayRefs: z.array(DisplayRef$outboundSchema),
  defaultDisplayRefs: z.array(DisplayRef$outboundSchema),
  deviceId: z.string(),
  displayName: z.string(),
  kind: z.string(),
}).transform((v) => {
  return remap$(v, {
    allDisplayRefs: "all_display_refs",
    defaultDisplayRefs: "default_display_refs",
    deviceId: "device_id",
    displayName: "display_name",
  });
});

export function deviceTrendPointsToJSON(
  deviceTrendPoints: DeviceTrendPoints,
): string {
  return JSON.stringify(
    DeviceTrendPoints$outboundSchema.parse(deviceTrendPoints),
  );
}
export function deviceTrendPointsFromJSON(
  jsonString: string,
): SafeParseResult<DeviceTrendPoints, SDKValidationError> {
  return safeParse(
    jsonString,
    (x) => DeviceTrendPoints$inboundSchema.parse(JSON.parse(x)),
    `Failed to parse 'DeviceTrendPoints' from JSON`,
  );
}
